var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screenfull-main"},[_c('el-tooltip',{attrs:{"effect":"light","placement":"bottom","content":_vm.isFullscreen ? '退出全屏' : '全屏'}},[_c('svg-icon',{attrs:{"icon-class":_vm.isFullscreen?'exit-fullscreen':'fullscreen'},on:{"click":_vm.handleClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }